document.addEventListener('contextmenu', e => {
  if (e.target.matches("audio")) {
    e.preventDefault()
  }
})
